import { render } from "./App.vue?vue&type=template&id=4e9ef050"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4e9ef050&lang=css"

import exportComponent from "/Users/tom/Projects/GitHub/contact-details/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__